"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class StudentActivityServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async fetchMyDailyXpStats(from, to) {
        this._validateMissingParams({ from, to });
        const url = `${this.url}/api/me/stats/xp/daily?from=${from}&to=${to}`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, { method: 'GET' }, expectedResponses);
        if (response.status === 400) {
            throw new client_library_1.BadRequestError('Invalid date parameter format', url, response.status);
        }
        return response.json;
    }
    async fetchMyGoals({ type, period }) {
        this._validateMissingParams({ type, period });
        const url = `${this.url}/api/me/goals?type=${type}&period=${period}`;
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, { method: 'GET' }, expectedResponses);
        if (response.status === 400) {
            throw new client_library_1.BadRequestError('Invalid query params', url, response.status);
        }
        return response.json;
    }
    async createGoal({ type, period, target }) {
        this._validateMissingParams({ type, period, target });
        const url = `${this.url}/api/me/goal`;
        const expectedResponses = [201, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                type,
                period,
                target
            })
        }, expectedResponses);
        if (response.status === 422) {
            throw new client_library_1.BadRequestError('Invalid body params', url, response.status);
        }
        return response.json;
    }
}
exports.default = StudentActivityServiceClient;
//# sourceMappingURL=StudentActivityServiceClient.js.map